import React from 'react';

const ErrorIcon = () => {
	return (
		<>
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6.99996 12.8327C10.2083 12.8327 12.8333 10.2077 12.8333 6.99935C12.8333 3.79102 10.2083 1.16602 6.99996 1.16602C3.79163 1.16602 1.16663 3.79102 1.16663 6.99935C1.16663 10.2077 3.79163 12.8327 6.99996 12.8327Z"
					stroke="#EC6A5E"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path d="M7 4.66602V7.58268" stroke="#EC6A5E" stroke-linecap="round" stroke-linejoin="round" />
				<path d="M6.99683 9.33398H7.00207" stroke="#EC6A5E" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</>
	);
};

export default ErrorIcon;
